import * as actionTypes from "../../constants/actionTypes";
import * as componentTypes from "../../constants/componentTypes";
import * as handlers from "../../constants/handlers";
import * as methods from "../../constants/methods";
import * as resultCodes from "../../constants/resultCodes";
import * as messageHelper from "../../helpers/messageHelper";
import * as navigationActions from "../../actions/navigationActions";
import * as responseHelper from "../../helpers/responseHelper";

export const processWebsocketResponse = (tabId, method, response, state) => {
    switch (method) {
        case handlers.ADD_COLOR_STATS:
        case handlers.ADD_COLOR_STATS_CORRECTION:
            if (!responseHelper.isAddColorStatsValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_STATISTICS_ID,
                    payload: {
                        colorStatsId: response.data.colorStatsId,
                        tabId: tabId
                    }
                },
                {
                    type: actionTypes.MACHINE_DISPENSE_FORMULA,
                    payload: {
                        colorStatsId: response.data.colorStatsId,
                        tabId: tabId
                    }
                }
            ];
        case handlers.ADD_COLOR_STATS_FROM_ORDER:
            if (response.result !== resultCodes.RESULT_OK || response.data.colorStatsId === undefined) {
                return [messageHelper.getFlashMessage(response)];
            }

            let toDispTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.TO_DISPENSE_TAB);

            return [
                {
                    type: actionTypes.TO_DISPENSE_START_FORMULA_DISPENSING,
                    payload: {
                        tabId: tabId,
                        colorStatsId: response.data.colorStatsId,
                        order: state.toDispense.activeOrder,
                        infoData: state.toDispense.infoData,
                        printData: state.toDispense.printData,
                        tmcData: state.toDispense.tmcData
                    }
                },
                {
                    type: actionTypes.TO_DISPENSE_LIST_UPDATE,
                    payload: {
                        tabId: toDispTab !== undefined ? toDispTab.id : 0
                    }
                }
            ];
        case handlers.ADD_COLOR_STATS_FROM_STATS:
            if (!responseHelper.isAddColorStatsValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            let addStatsRequest = state.server.requests.find((request) => request.id === response.sequence);

            if (addStatsRequest.next === null || addStatsRequest.next.packageCount === undefined) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                navigationActions.closeModal(componentTypes.RETINT_MODAL),
                navigationActions.openNewMainTab(
                    tabId,
                    true,
                    addStatsRequest.next.packageCount,
                    response.data.colorStatsId
                )
            ];
        case handlers.ADD_COLOR_STATS_DIRECTLY:
            if (!responseHelper.isAddColorStatsValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SAVE_FORMULA_STATISTICS_ID,
                    payload: {
                        colorStatsId: response.data.colorStatsId,
                        tabId: tabId
                    }
                },
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_ADD_AND_FINISH_ALL_DISPENSED_PACKAGE,
                        params: {
                            colorStatsId: response.data.colorStatsId,
                            tabId: tabId
                        }
                    },
                    method: handlers.ADD_AND_FINISH_ALL_DISPENSED_PACKAGE,
                    tabId: tabId
                }
            ];
        case handlers.ADD_COLOR_STATS_FROM_ORDER_DIRECTLY:
            if (response.result !== resultCodes.RESULT_OK || response.data.colorStatsId === undefined) {
                return [messageHelper.getFlashMessage(response)];
            }

            return [
                {
                    type: actionTypes.SERVER_REQUEST,
                    payload: {
                        type: methods.METHOD_ADD_AND_FINISH_ALL_DISPENSED_PACKAGE,
                        params: {
                            colorStatsId: response.data.colorStatsId,
                            tabId: tabId
                        }
                    },
                    method: handlers.ADD_AND_FINISH_ALL_DISPENSED_PACKAGE,
                    tabId: tabId
                }
            ];
        case handlers.ADD_QUICK_TINT_INTO_STATISTICS:
            if (response.result !== resultCodes.RCC_RESULT_OK) {
                return [messageHelper.getRccFlashMessage(response)];
            }

            return [];
        case handlers.ADD_QUICK_TINT_STATS_DIRECTLY:
            if (!responseHelper.isAddColorStatsValid(response)) {
                return [messageHelper.getFlashMessage(response)];
            }

            let finishQuickTintActions = [
                {
                    type: actionTypes.SAVE_FORMULA_STATISTICS_ID,
                    payload: {
                        colorStatsId: response.data.colorStatsId,
                        tabId: tabId
                    }
                },
                messageHelper.getSuccessMessageAction("flashMessage.savedFormulaToHistory")
            ];

            let openedStatsTab = state.navigation.tabList.find((tab) => tab.type === componentTypes.STATISTICS_TAB);

            if (openedStatsTab !== undefined) {
                finishQuickTintActions.push({
                    type: actionTypes.STATISTICS_LIST_UPDATE,
                    payload: {
                        tabId: openedStatsTab.id
                    }
                });
            }

            return finishQuickTintActions;
        default:
            return [
                {
                    type: actionTypes.UNKNOWN_ACTION
                }
            ];
    }
};
